import { TDatabaseId } from '@infotech-soe/metaschema';

import { NotificationsViewModel } from '../../../../store/slices/notifications';

const handleNotificationClicked = (
  value: TDatabaseId,
  notifications: NotificationsViewModel,
  onNotificationClick: (id: TDatabaseId) => void
): void => {
  const notification = Object.values(notifications).find(n => n.id === value);

  if (!notification) {
    return;
  }

  onNotificationClick(notification.id);
};

export default handleNotificationClicked;
